import { useContext } from "react";
import { PartnerListPageContext, PageNewState } from ".";

export const usePageState = () => {
  const { pageState, setPageState } = useContext(PartnerListPageContext);
  return [
    pageState,
    (newState: PageNewState) => setPageState(newState),
  ] as const;
};
